import {
    Badge,
    Box,
    Button,
    Checkbox,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { faSpinnerThird, faTimeline } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../../../common';
import { getShortlinks } from '../../../../../http/apiClient';
import { useForm } from '@mantine/form';
import useReplaceCampaignShortLink from '../../../../../http/mutations/campaigns/useReplaceCampaignShortLink';

const ReplaceCampaignShortLinkModal = ({
    campaign,
    openTab,
    opened,
    close,
}) => {
    const getInitialValues = () => ({
        campaignId: campaign?.id.toString(),
        newShortLinkId: '',
        replaceAll: false,
    });
    const form = useForm({
        initialValues: getInitialValues(),

        validate: {
            newShortLinkId: (value) => {
                if (!value) {
                    return 'Select new shortlink';
                }
            },
            /*emailOrUsername: isNotEmpty('Username or email is required'),
                    password: (val) =>
                        val.length <= 6
                            ? 'Password should include at least 6 characters'
                            : null,*/
        },
    });

    useEffect(() => {
        form.setInitialValues(getInitialValues());
        form.reset();
    }, [opened]);

    const { isPending, mutate: replaceShortLink } =
        useReplaceCampaignShortLink();

    const onSubmit = (model) => {
        replaceShortLink(model, {
            onSuccess: () => {
                close();
            },
        });
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size='md'>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>
                        {campaign
                            ? `Replace ${campaign.name} ShortLink`
                            : 'Replace Shortlink'}
                    </Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'sm'}>
                            <SearchableSelect
                                label={'New Short Link'}
                                placeholder='Select short link to replace current with '
                                queryHttpFn={(queryParams) =>
                                    getShortlinks(queryParams)
                                }
                                queryKey={'short_links'}
                                optionsMapFn={(x) => ({
                                    label: x.domain,
                                    value: x.id.toString(),
                                })}
                                key={form.key('newShortLinkId')}
                                {...form.getInputProps('newShortLinkId')}
                            />

                            <Checkbox
                                label={'Replace for all campaigns'}
                                key={form.key('replaceAll')}
                                {...form.getInputProps('replaceAll')}
                                checked={form.values.replaceAll}
                            />

                            <Button
                                type={'submit'}
                                size={'compact-sm'}
                                disabled={!form.isValid() || isPending}
                                rightSection={
                                    isPending ? (
                                        <FontAwesomeIcon
                                            icon={faSpinnerThird}
                                            spin
                                        />
                                    ) : null
                                }>
                                Start
                            </Button>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default ReplaceCampaignShortLinkModal;
